import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TEASER_BOXES_HOMEPAGE_CONVERTER_TOKEN, TeaserBoxesHomepageConverter } from './teaser-boxes-homepage.component.converter'
import {
  TEASER_BOX_HOMEPAGE_IMAGE_CONVERTER_TOKEN, TeaserBoxHomepageImageConverter
} from './teaser-box-homepage/teaser-box-homepage-image.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        teaserBoxesHomepageFeature: {
          module: () => import('./teaser-boxes-homepage.module').then((m) => m.TeaserBoxesHomepageModule),
          cmsComponents: ['teaserbox_homepage'],
        },
      }
    }),
    {
      provide: TEASER_BOXES_HOMEPAGE_CONVERTER_TOKEN,
      useClass: TeaserBoxesHomepageConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaserbox_homepage: TEASER_BOXES_HOMEPAGE_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TEASER_BOX_HOMEPAGE_IMAGE_CONVERTER_TOKEN,
      useClass: TeaserBoxHomepageImageConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaserbox_homepage_image: TEASER_BOX_HOMEPAGE_IMAGE_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class TeaserBoxesHomepageFeatureModule {}
